import React from 'react'

import * as S from './styles.js'
import { isArray } from 'lodash'

const HeaderPage = ({ icon, iconBoxStyle, title, sub, loading, action }) => {
  return <S.Container>
    <S.BoxItem>
      <S.Circle style={iconBoxStyle}>
        {icon}
      </S.Circle>
      <S.BoxText>
        {loading ? (
          <>
            <S.SkeletonCard height={29} />
            <S.SubBlock>
              {Array(3).fill().map((_, index) => <S.SkeletonCard key={index} height={16} />)}
            </S.SubBlock>
          </>
        ) : (
          <>
            <S.Title>{title}</S.Title>
            <S.SubBlock>
              {isArray(sub)
                ? sub.map((sub, index) => {
                  return <S.SubItem key={`${index}-${sub}`}>{sub}</S.SubItem>
                })
                : <S.SubTitle>{sub}</S.SubTitle>
              }
            </S.SubBlock>
          </>
        )}

      </S.BoxText>
    </S.BoxItem>
    {action && action}
  </S.Container>
}

export default HeaderPage
